<template>
	<div class="p-6">
		<h1 class="text-2xl font-semibold text-gray-900 mb-4" v-if="hasH1">
			{{ __("Edit base data") }}
		</h1>

		<div class="grid grid-cols-8 gap-y-4 gap-x-6">
			<ui-input-group
				class="col-span-8 md:col-span-4"
				v-model="form.company_name"
				field="company_name"
				label="Company"
				:form="form"
				:required="true"
			></ui-input-group>
			<ui-select-group
				v-model="form.type"
				class="col-span-8 md:col-span-4"
				field="type"
				type="select"
				v-if="canEditCompanyType"
				label="Type of company"
				:options="$cropOptions.companyTypeOptions"
				:form="form"
				:required="true"
			>
			</ui-select-group>
			<span class="col-span-8 md:col-span-4" v-else>
				<div class="flex justify-between flex-wrap">
					<label class="block font-medium">{{ __("Type of company") }}</label>
				</div>
				<div class="mt-1 inline-block align-bottom" style="height: 37px">
					{{
						__(
							$cropOptions.getLabel(form.type, $cropOptions.companyTypeOptions)
						)
					}}
				</div>
			</span>

			<ui-input-group
				v-model="form.address.street"
				class="col-span-8 md:col-span-5"
				field="address.street"
				label="Street + house number"
				:form="form"
				:required="true"
			></ui-input-group>

			<crop-location-picker
				class="col-span-8 mt-0"
				v-model="form.address"
				:form="form"
			>
			</crop-location-picker>

			<ui-input-group
				v-if="hasEuVatId"
				class="col-span-8 md:col-span-4"
				v-model="form.eu_vatid"
				field="eu_vatid"
				label="Tax Identifier"
				:form="form"
				:required="false"
			></ui-input-group>

			<ui-select-group
				v-if="hasEuVatId"
				class="col-span-8 md:col-span-4"
				v-model="form.preferred_language"
				type="select"
				field="preferred_language"
				label="Preferred Language"
				:options="$cropOptions.languageOptions"
				:form="form"
				:required="true"
				@change="triggerReload"
			>
			</ui-select-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
		hasEuVatId: {
			type: Boolean,
			default: true,
		},
		hasH1: {
			type: Boolean,
			default: true,
		},
		canEditCompanyType: {
			type: Boolean,
			default: false,
		},
	},
	data: function () {
		return {
			companyTypeOptions: this.$cropOptions.companyTypeOptions,
			countryOptions: this.$cropOptions.countryOptions,
		};
	},
	methods: {
		triggerReload() {
			if ("parentIFrame" in window) {
				window.parentIFrame.sendMessage("FULL_RELOAD");
			}
		},
	},
};
</script>
